import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const block = 'rail';

const Rail = ({ children, className, ...rest }) => (
  <div className={classNames(block, 'rail__main', className)} {...rest}>
    <div className="rail__wrapper">
      <div className="rail__content">
        {children}
      </div>
    </div>
  </div>
);

Rail.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]),
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};

Rail.defaultProps = {
  children: null,
  className: null,
};

export default Rail;
